import {getQueryFilter} from 'utils/helper'
import {DOCS} from './endpoint'
import {
  GET_DOC_DETAILS,
  UPDATE_DOC_DETAILS,
  UPDATE_DOC_SETTINGS,
  DELETE_KB,
  CREATE_KNOWLEDGEBASE,
  GET_KNOWLEDGEBASE,
  GET_CATEGORIES,
  CREATE_CATEGORY,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  GET_ARTICLES_DOC,
  GET_ARTICLES_CATEGORY,
  CREATE_ARTICLE,
  UPDATE_ARTICLE,
  DELETE_ARTICLE,
  GET_CATEGORY_DETAILS,
  GET_ARTICLE_DETAIL,
  UPLOAD_IMAGE_CUSTOMIZATION,
  UPLOAD_LOGO_CUSTOMIZATION,
  UPLOAD_FAVICON_CUSTOMIZATION,
  UPLOAD_LOGO_CATEGORY,
  UPLOAD_LOGO_ARTICLE,
  RESTORE_ARTICLE_DATA,
  UPDATE_CATEGORY_REORDERING,
  UPDATE_ARTICLE_REORDERING,
  UPDATE_DOC_CSS_AND_JS,
  CREATE_REDIRECT_RULES,
  GET_REDIRECT_RULE,
  DELETE_REDIRECT_RULE,
  UPDATE_REDIRECT_RULE,
  IMPORT_KNOWLEDGEBASE,
  EXPORT_KNOWLEDGEBASE,
  CONTENT_FROM_EXTERNAL_KNOWLEDGEBASE,
  GET_EXPORT_DOC_DETAILS,
} from './types'
import {apiAction} from './api'
import * as endpoint from './endpoint'

// Settings Knowledgebase
export function getDocDetails(docId) {
  return apiAction({
    url: `${DOCS}/getDocDetail?docId=${docId}`,
    method: 'GET',
    label: GET_DOC_DETAILS,
  })
}

export function getCategoryDetails(categoryId) {
  return apiAction({
    url: `${DOCS}/category/getCategoryDetail?categoryId=${categoryId}`,
    method: 'GET',
    label: GET_CATEGORY_DETAILS,
  })
}

export function deleteKB(data) {
  return apiAction({
    url: `${DOCS}/deleteDoc`,
    method: 'POST',
    label: DELETE_KB,
    data,
    showToast: true,
    successMessage: 'KnowledgeBase Deleted',
  })
}

export function updateDocSettings(data) {
  return apiAction({
    url: `${DOCS}/updateDocSettings`,
    method: 'POST',
    label: UPDATE_DOC_SETTINGS,
    data,
    showToast: true,
    successMessage: 'Settings Updated',
  })
}

export function updateDocDetails(data) {
  return apiAction({
    url: `${DOCS}/updateDoc`,
    method: 'POST',
    label: UPDATE_DOC_DETAILS,
    data,
    showToast: true,
    successMessage: 'Updated Successfully',
  })
}

// knowledgebase
export function getKnowledgebase() {
  return apiAction({
    url: `${DOCS}/getDocs`,
    method: 'GET',
    label: GET_KNOWLEDGEBASE,
    showToast: true,
  })
}

export function createKnowledgebase(data) {
  return apiAction({
    url: `${DOCS}/createDoc`,
    method: 'POST',
    label: CREATE_KNOWLEDGEBASE,
    data,
    showToast: true,
    successMessage: 'Knowledgebase Created',
  })
}

// categories
export function getCategories(docId, orderBy) {
  let url = `${DOCS}/category/getCategories?docId=${docId}`
  if (orderBy) url = `${url}&orderBy=${orderBy}`
  return apiAction({
    url,
    method: 'GET',
    label: GET_CATEGORIES,
  })
}
export function createCategory(data) {
  return apiAction({
    url: `${DOCS}/category/createCategory`,
    method: 'POST',
    label: CREATE_CATEGORY,
    data,
  })
}

export function deleteCategory(data) {
  return apiAction({
    url: `${DOCS}/category/deleteCategory`,
    method: 'DELETE',
    label: DELETE_CATEGORY,
    data,
    showToast: true,
    successMessage: 'Category Deleted',
    reduxData: {categoryId: data?.id},
  })
}
export function updateCategory(data) {
  return apiAction({
    url: `${DOCS}/category/updateCategory`,
    method: 'PUT',
    label: UPDATE_CATEGORY,
    data,
    showToast: true,
    successMessage: 'Category Updated',
  })
}

// articles

export function getArticlesByDoc(docId, params) {
  // prams :- text, categoryId, status, isTrashed, orderBy
  let url = `${DOCS}/article/getArticles?docId=${docId}`
  const qs = getQueryFilter(params)
  if (qs) {
    url += `&${qs}`
  }

  return apiAction({
    url,
    method: 'GET',
    label: GET_ARTICLES_DOC,
  })
}

export function getArticleDetail(articleId) {
  return apiAction({
    url: `${DOCS}/article/getArticleDetail?articleId=${articleId}`,
    method: 'GET',
    label: GET_ARTICLE_DETAIL,
  })
}
export function getArticlesByCategory(categoryId, docId) {
  return apiAction({
    url: `${DOCS}/article/getArticles?categoryId=${categoryId}&docId=${docId}`,
    method: 'GET',
    label: GET_ARTICLES_CATEGORY,
  })
}
export function createArticle(data) {
  return apiAction({
    url: `${DOCS}/article/createArticle`,
    method: 'POST',
    label: CREATE_ARTICLE,
    data,
    showToast: true,
    successMessage: 'Article Created',
  })
}

export function updateArticle(data) {
  return apiAction({
    url: `${DOCS}/article/updateArticle`,
    method: 'PUT',
    label: UPDATE_ARTICLE,
    data,
    showToast: true,
    successMessage: 'Article Updated',
  })
}
export function deleteArticle(id) {
  const data = {
    id,
  }

  return apiAction({
    url: `${DOCS}/article/deleteArticle`,
    method: 'DELETE',
    label: DELETE_ARTICLE,
    data,
    showToast: true,
    successMessage: 'Article Deleted',
  })
}
export function uploadLogoArticle(data) {
  return apiAction({
    url: `${endpoint.DOCS}/fileUpload`,
    method: 'POST',
    label: UPLOAD_LOGO_ARTICLE,
    contentType: 'multipart/form-data',
    data,
  })
}

export function uploadLogoCategory(data) {
  return apiAction({
    url: `${endpoint.DOCS}/fileUpload`,
    method: 'POST',
    label: UPLOAD_LOGO_CATEGORY,
    contentType: 'multipart/form-data',
    data,
  })
}

export function uploadImageCustomization(data) {
  return apiAction({
    url: `${endpoint.DOCS}/fileUpload`,
    method: 'POST',
    label: UPLOAD_IMAGE_CUSTOMIZATION,
    contentType: 'multipart/form-data',
    data,
  })
}

export function uploadLogoCustomization(data) {
  return apiAction({
    url: `${endpoint.DOCS}/fileUpload`,
    method: 'POST',
    label: UPLOAD_LOGO_CUSTOMIZATION,
    contentType: 'multipart/form-data',
    data,
  })
}

export function uploadFaviconCustomization(data) {
  return apiAction({
    url: `${endpoint.DOCS}/fileUpload`,
    method: 'POST',
    label: UPLOAD_FAVICON_CUSTOMIZATION,
    contentType: 'multipart/form-data',
    data,
  })
}

export function restoreArticle(data) {
  return apiAction({
    url: `${endpoint.DOCS}/article/restoreArticle`,
    method: 'POST',
    label: RESTORE_ARTICLE_DATA,
    data,
    showToast: true,
    successMessage: 'Article Restored',
  })
}

export function updateCategoryReordering(obj) {
  let URL = ''
  if (obj.preId && obj.nextId && obj.selectedId && obj.docId) {
    URL = `${DOCS}/category/updateCategorySequence/${obj.selectedId}?prevId=${obj.preId}&nextId=${obj.nextId}&docId=${obj.docId}`
  } else if (obj.nextId && obj.selectedId && obj.docId) {
    URL = `${DOCS}/category/updateCategorySequence/${obj.selectedId}?nextId=${obj.nextId}&docId=${obj.docId}`
  } else if (obj.preId && obj.selectedId && obj.docId) {
    URL = `${DOCS}/category/updateCategorySequence/${obj.selectedId}?prevId=${obj.preId}&docId=${obj.docId}`
  }
  return apiAction({
    url: URL,
    method: 'POST',
    label: UPDATE_CATEGORY_REORDERING,
  })
}
export function updateArticleReordering(obj) {
  let URL = ''
  if (obj.preId && obj.nextId && obj.selectedId && obj.docId) {
    URL = `${DOCS}/article/updateArticleSequence/${obj.selectedId}?prevId=${obj.preId}&nextId=${obj.nextId}&docId=${obj.docId}&categoryId=${obj.categoryId}`
  } else if (obj.nextId && obj.selectedId && obj.docId) {
    URL = `${DOCS}/article/updateArticleSequence/${obj.selectedId}?nextId=${obj.nextId}&docId=${obj.docId}&categoryId=${obj.categoryId}`
  } else if (obj.preId && obj.selectedId && obj.docId) {
    URL = `${DOCS}/article/updateArticleSequence/${obj.selectedId}?prevId=${obj.preId}&docId=${obj.docId}&categoryId=${obj.categoryId}`
  }
  return apiAction({
    url: URL,
    method: 'POST',
    label: UPDATE_ARTICLE_REORDERING,
  })
}

export function updateDocCssAndJs(data) {
  return apiAction({
    url: `${DOCS}/updateDocCSSJS`,
    method: 'POST',
    label: UPDATE_DOC_CSS_AND_JS,
    data,
    showToast: true,
    successMessage: 'Custom Css and Js Updated',
  })
}

export function createRedirectRules(data) {
  return apiAction({
    url: `${DOCS}/article_redirect_url/addArticleRedirectRule`,
    method: 'POST',
    label: CREATE_REDIRECT_RULES,
    data,
  })
}

export function getRedirectRule(docId) {
  return apiAction({
    url: `${DOCS}/article_redirect_url/getArticleRedirectRule?docId=${docId}`,
    method: 'GET',
    label: GET_REDIRECT_RULE,
  })
}

export function deleteRedirectRule(data) {
  return apiAction({
    url: `${DOCS}/article_redirect_url/deleteArticleRedirectRule`,
    method: 'DELETE',
    label: DELETE_REDIRECT_RULE,
    data,
    showToast: true,
    successMessage: 'Deleted',
  })
}

export function updateRedirectRule(data) {
  return apiAction({
    url: `${DOCS}/article_redirect_url/updateArticleRedirectRule `,
    method: 'PUT',
    label: UPDATE_REDIRECT_RULE,
    data,
    showToast: true,
    successMessage: 'Updated',
  })
}

export function exportKnowledgebase(docId) {
  return apiAction({
    url: `${DOCS}/exportKB/exportDoc?docId=${docId}`,
    method: 'GET',
    label: EXPORT_KNOWLEDGEBASE,
    showToast: true,
    successMessage: 'Exported Successfully',
  })
}

export function importKnowledgebase(docId, data) {
  return apiAction({
    url: `${DOCS}/importKB/uploadKB?docId=${docId}`,
    method: 'POST',
    label: IMPORT_KNOWLEDGEBASE,
    data,
    contentType: 'multipart/form-data',
    showToast: true,
    successMessage: 'Import Successfull',
  })
}

export function contentFromExternalKnowledgebase(data) {
  return apiAction({
    url: `${DOCS}/importKB/importDocs`,
    method: 'POST',
    label: CONTENT_FROM_EXTERNAL_KNOWLEDGEBASE,
    data,
    showToast: true,
    successMessage: 'Import Successfull',
  })
}

export function getExportDocs(docId) {
  return apiAction({
    url: `${DOCS}/importKB/getExportDocs?docId=${docId}`,
    method: 'GET',
    label: GET_EXPORT_DOC_DETAILS,
  })
}
